import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation, } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import OnboardingRoute from './OnboardingRoute';
import PublicRoute from './PublicRoute';
import Login from '../pages/login/login';
import RecoveryPassword from '../pages/login/recoveryPassword.js';
import RecoveryPin from '../pages/login/recoveryPin.js';

import Home from '../pages/dashboard/home';
import Sidebar from '../components/sidebar/sidebarMain';
import { AuthContext } from '../context/AuthContext';
import Splash from '../pages/splash/Splash';
import Registro from '../pages/registro/registro';
import Banned from '../pages/registro/Banned';
import LocationTutorial from '../components/tutoriales/LocationTutorial.js';


import Welcome from '../pages/registro/welcome';
import Documentation from '../pages/registro/documentationLegal';
import Rejected from '../pages/registro/Rejected.js';
import DocumentationComplete from '../pages/registro/documentationComplete';
import VerificationBecomeUser from '../pages/verification/VerificationBecomeUser.js'
import VerificationBecomeCompany from '../pages/verification/VerificationBecomeCompany.js'
import Quote from '../pages/cotizar/Quote.js';
import NaturalPersonCompleted from '../pages/dashboard/naturalPersonCompleted.js'

import WalletCop from '../pages/dashboard/walletCop.js'
import WalletUsd from '../pages/dashboard/walletUsd.js'
import WalletUsdt from '../pages/dashboard/walletUsdt.js'
import Inversiones from '../pages/inversiones/Inversiones.js'




import SplashDocumentacion from '../pages/splash/splashDocumentation';
import MyWallet from '../pages/myWallet/myWallet.js';
import { UtilContext } from '../context/UtilContext.js';

const AppRouter = () => {
    const { isAuth, StatusDocument } = useContext(AuthContext);
    const { longitude, latitude, loadingLocation } = useContext(UtilContext);

    const location = useLocation();


    // Rutas donde no se debe mostrar el Sidebar
    const hideSidebarPaths = [
        "/splash",
        "/bienvenido",
        "/documentacion-legal",
        "/verification-user",
        "/verification-company",
        "/documentacion-completa",
        "/persona-natural",
        "/subida-documentos",
        "/empresas",

    ];
    const shouldHideSidebar = hideSidebarPaths.some(path =>
        location.pathname.startsWith(path) ||
        (path.includes('/:id') && location.pathname.startsWith(path.split('/:id')[0]))
    );


    return (
        <div className="flex">

            {/* Mostrar el Sidebar solo si el usuario está autenticado y la ruta no está en hideSidebarPaths */}
            {isAuth && !shouldHideSidebar && (
                <div className="bg-trixel-sidebar">
                    <Sidebar />
                </div>
            )}



            {/* Contenedor de rutas */}
            <div className="flex-grow overflow-auto h-screen bg-[#141319]">
                {isAuth && !longitude && !latitude && !loadingLocation && StatusDocument == "APPROVED" && <LocationTutorial />}
                <Routes>
                    {/* Redirección inicial */}
                    <Route path="/" element={isAuth ? StatusDocument !== "APPROVED" ? <Navigate to="/splash" /> : <Navigate to="/dashboard" /> : <Navigate to="/login" />} />

                    {/* Rutas públicas */}
                    <Route path="/splash" element={<OnboardingRoute element={<Splash />} />} />
                    <Route path="/login" element={<PublicRoute element={<Login />} />} />
                    <Route path="/cambiar-contraseña" element={<PublicRoute element={<RecoveryPassword />} />} />
                    <Route path="/cambiar-pin" element={<PublicRoute element={<RecoveryPin />} />} />

                    <Route path="/registro" element={<PublicRoute element={<Registro />} />} />
                    <Route path="/verification-user/:id" element={<PublicRoute element={<VerificationBecomeUser />} />} />
                    <Route path="/verification-company/:id" element={<PublicRoute element={<VerificationBecomeCompany />} />} />

                    {/* Rutas privadas */}
                    <Route path="/dashboard" element={<PrivateRoute element={<Home />} />} />
                    <Route path="/persona-natural" element={<PrivateRoute element={<NaturalPersonCompleted />} />} />
                    <Route path="/empresas" element={<PrivateRoute element={<NaturalPersonCompleted />} />} />
                    <Route path="/wallet" element={<PrivateRoute element={<MyWallet />} />} />
                    <Route path="/cotizar" element={<PrivateRoute element={<Quote />} />} />
                    <Route path="/wallet-cop" element={<PrivateRoute element={<WalletCop />} />} />
                    <Route path="/wallet-usd" element={<PrivateRoute element={<WalletUsd />} />} />
                    <Route path="/wallet-usdt" element={<PrivateRoute element={<WalletUsdt />} />} />
                    <Route path="/portafolio" element={<PrivateRoute element={<Inversiones />} />} />

                    {/*  Rutas de Onboarding */}
                    <Route path="/bienvenido" element={<OnboardingRoute element={<Welcome />} />} />
                    {/*                     <Route path="/bienvenido" element={<OnboardingRoute element={<Inversion />} />} />
 */}
                    <Route path="/subida-documentos" element={<OnboardingRoute element={<Rejected />} />} />
                    <Route path="/bloqueado" element={<OnboardingRoute element={<Banned />} />} />
                    <Route path="/splash-documentos" element={<OnboardingRoute element={<SplashDocumentacion />} />} />
                    <Route path="/documentacion-legal" element={<OnboardingRoute element={<Documentation />} />} />
                    <Route path="/documentacion-completa" element={<OnboardingRoute element={<DocumentationComplete />} />} />
                    <Route path="/*" element={<Navigate to="/" />} />
                </Routes >
            </div >
        </div >
    );
};

export default AppRouter;
